import React from 'react';
import TabelaPadrao from './TabelaPadrao';

function labelTipo(t) {
  if (!t) return '\u2014';
  if (t === 'M') return '\uD83C\uDFCD\uFE0F Moto';
  if (t === 'PM') return '\uD83D\uDE94 PM';
  return '\uD83D\uDE97 Dupla';
}

function fmt2(val) {
  return (val ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const COLUMNS = [
  { key: 'regiao', label: 'Região', align: 'center', render: (val) => <span style={{ fontWeight: 600, fontSize: 'var(--font-sm)' }}>{val || '\u2014'}</span> },
  { key: 'tipo_turma', label: 'Tipo', align: 'left', render: (val) => <span style={{ fontWeight: 600 }}>{labelTipo(val)}</span> },
  { key: 'qtd_veiculos', label: 'Quantidade de veículos', align: 'center', render: (val) => <span style={{ fontVariantNumeric: 'tabular-nums' }}>{val}</span> },
  { key: 'total_geral', label: 'Total US', align: 'right', render: (val) => <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--amber)', fontWeight: 600 }}>{fmt2(val)}</span> },
  { key: 'media_por_equipe', label: 'Média', align: 'right', render: (val) => <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--amber)', fontWeight: 700 }}>{fmt2(val)}</span> },
];

export default function TabelaMediaEquipes({ dados }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', padding: '20px', height: '100%', boxSizing: 'border-box' }}>
      <div style={{ fontSize: 'var(--font-sm)', fontWeight: 600, color: 'var(--amber)', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        Média por Tipo de Equipe
      </div>
      <TabelaPadrao columns={COLUMNS} data={dados} emptyMessage='Nenhuma equipe encontrada' />
    </div>
  );
}
